import { Button } from "@Light/components/page/Button";
import { EnrollBottomSheet } from "../common/EnrollBottomSheet";
import { SupportContactRows } from "../SupportContactRows";

export type UnallowedAddressChangeSheetProps = {
  open: boolean;
  onClose: () => void;
};

export function UnallowedAddressChangeSheet({
  open,
  onClose,
}: UnallowedAddressChangeSheetProps) {
  return (
    <EnrollBottomSheet
      open={open}
      onClose={onClose}
      title="Please reach out to us"
      subtitle="Our support team will be able to change your address."
      data-testid="unallowed-address-change-sheet"
      footer={
        <Button
          size="lg"
          buttonType="outline"
          className="w-full"
          onClick={onClose}
        >
          Close
        </Button>
      }
    >
      <SupportContactRows />
    </EnrollBottomSheet>
  );
}
